import { render, staticRenderFns } from "./ModalMigracao.vue?vue&type=template&id=68e01d7f&"
import script from "./ModalMigracao.vue?vue&type=script&lang=js&"
export * from "./ModalMigracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports